module['exports'] = ['bear', 'lion', 'insect', 'crocodilia', 'cow'];
